import NCRDialogComponent from './NCRDialog';

// Named exports
export { default as NCRDialog } from './NCRDialog';
export { default as NCRForm } from './NCRForm';
export { default as IPIForm } from './IPIForm';
export { default as CustomerComplaintForm } from './CustomerComplaintForm';
export { default as EnhancedNCRForm } from './EnhancedNCRForm';

// Default export (for backward compatibility)
export default NCRDialogComponent;